import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-deliverGoods",
  "use": "icon-deliverGoods-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-deliverGoods\"><path d=\"M128 864c0 17.6 14.4 32 32 32h704c17.6 0 32-14.4 32-32V320H128v544z m447.2-288H768v64H575.2v-64z m-64 128H768v64H511.2v-64z m-16-416h-368l76.8-135.2c12-16 30.4-24.8 50.4-24.8h240.8v160z m401.6 0h-368V128h240.8c20 0 38.4 9.6 50.4 24.8l76.8 135.2z\" p-id=\"4656\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol